<template>
    <v-select
        v-if="mealTypes.length"
        :label="$t('change_extra_meal_type')"
        :items="mealTypes"
        item-value="id"
        :item-title="mealTypeLabel"
        :prepend-item="{name: '', value: null}"
        :clearable="clearable"
        :model-value="alternativeMealTypeId"
        :disabled="disabled"
        variant="outlined"
        density="comfortable"
        @update:model-value="update"
    />
</template>

<script lang="ts">
    import {Vue, Component, Prop, Model} from 'vue-facing-decorator'

    @Component
    export class MealTypeSelector extends Vue {
        @Model() alternativeMealTypeId
        @Prop() roomIndex
        @Prop() standardMealName
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) isTourLead
        @Prop({required: true}) tourist

        mounted() {
            this.update(this.alternativeMealTypeId)
        }

        mealTypeLabel({name, prices}) {
            const price = hotelsRuntimeStore.mealTypePrice(prices, this.tourist)
            const selectedMealTypePrice = hotelsRuntimeStore.mealTypePrice(this.selectedMealType.prices, this.tourist)
            const deltaPrice = {
                amount: price.amount - selectedMealTypePrice.amount,
                currency: price.currency,
            }
            return name + (deltaPrice.amount ? ` (${this.$filters.price(deltaPrice)})` : '')
        }

        update(value: number) {
            const mealType = this.mealTypes.find(el => el.id === value)
            if (!mealType) {
                value = null
            }
            this.alternativeMealTypeId = value
        }

        get selectedMealType() {
            return this.mealTypes.find(({id}) => id === this.alternativeMealTypeId)
        }

        get mealTypes() {
            const meals = hotelsStore.extraMealTypes
            return meals[this.roomIndex]
                ? meals[this.roomIndex]
                      .filter(el => hotelsRuntimeStore.mealTypePrice(el.prices, this.tourist))
                      .sort((a, b) =>
                          hotelsRuntimeStore.mealTypePrice(a.prices, this.tourist).amount <
                          hotelsRuntimeStore.mealTypePrice(b.prices, this.tourist).amount
                              ? -1
                              : 1
                      )
                : []
        }

        get clearable() {
            return this.selectedMealType.name !== this.standardMealName
        }
    }

    export default MealTypeSelector
</script>
